import { Button, Form, Select } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react';
import { useAllActiveRadiologistList } from '../../../hooks/radiologists/useAllActiveRadiologistsList';

const AssignRadiologistForm = forwardRef(function AssignRadiologistForm(
  { formValues, onSubmit, loading, isEdit = false },
  ref
) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    values: formValues,
  });
  const {data, getList} = useAllActiveRadiologistList();

  const radioLogistUsers = useMemo(() => {
    return data?.items?.map(d => ({label: `${d?.fullName} ${d?.email}`, value: d?.sub})) || [];
  },[data?.items]);

  useEffect(() => {
    getList();
  }, []);


  useImperativeHandle(
    ref,
    () => ({
      reset: reset,
    }),
    [reset]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          Radiologist <span className="login-danger">*</span>
        </label>
        <Controller
          name="radioLogistUserSub"
          control={control}
          disabled={isEdit}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              options={radioLogistUsers}
            />
          )}
        />

        <small style={{ color: 'red' }}>
          {errors.radioLogistUserSub && <p>Please select a radiologist</p>}
        </small>
      </div>
      <div className="form-group">
        <label>Revenue Amount</label>
        <input
          className="form-control"
          type="number"
          disabled={isEdit}
          {...register('revenueAmount', {
            required: true,
            valueAsNumber: true,
          })}
        />
        <small style={{ color: 'red' }}>
          {errors.revenueAmount && <p>Please enter valid revenue amount</p>}
        </small>
      </div>
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
    </form>
  );
});
AssignRadiologistForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default AssignRadiologistForm;
